import React, { useState, useEffect, useRef } from 'react';
import { PitchDetector } from 'pitchy';
import './PitchDetectorComponent.css';

function generateFrequencyTable() {
    const referenceFrequency = 440;  // A4
    const semitoneRatio = Math.pow(2, 1/12);
    const notes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
    
    let table = [];
    let currentNoteIndex = 4;
    let currentOctave = 2;

    while (!(currentNoteIndex === 11 && currentOctave === 8)) {
        let n = notes[currentNoteIndex] + currentOctave;
        let f = referenceFrequency * Math.pow(semitoneRatio, currentNoteIndex - 9 + (currentOctave - 4) * 12);
        table.push({note: n, frequency: parseFloat(f.toFixed(2))});

        if (currentNoteIndex === 11) {
            currentNoteIndex = 0;
            currentOctave++;
        } else {
            currentNoteIndex++;
        }
    }

    return table;
}

const FREQUENCIES = generateFrequencyTable();
console.log(FREQUENCIES);

function closestNote(frequency) {
  return FREQUENCIES.reduce((prev, curr) =>
    Math.abs(curr.frequency - frequency) < Math.abs(prev.frequency - frequency) ? curr : prev
  );
}


function PitchDetectorComponent({ onPitchDetected, visible }) {
  const [detectedNote, setDetectedNote] = useState(null);
  const [clarity, setClarity] = useState(0);

  const [lastUpdate, setLastUpdate] = useState(Date.now());
  const pendingNoteRef = useRef(null);

  useEffect(() => {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const inputLength = 1024;  // You can adjust this value as needed
    const pitchDetector = PitchDetector.forFloat32Array(inputLength);

    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      const source = audioContext.createMediaStreamSource(stream);
      const scriptProcessor = audioContext.createScriptProcessor(inputLength, 1, 1);
      source.connect(scriptProcessor);
      scriptProcessor.connect(audioContext.destination);
      scriptProcessor.onaudioprocess = event => {
        const inputBuffer = event.inputBuffer.getChannelData(0);
        const [pitch, clarityValue] = pitchDetector.findPitch(inputBuffer, audioContext.sampleRate);

        if (clarityValue > 0.75) {  // This threshold can be adjusted as needed
          const note = pitchToNote(pitch);
          const closest = closestNote(pitch);
          const centsDifference = 1200 * Math.log2(pitch / closest.frequency);

          if (note !== pendingNoteRef.current) {
            pendingNoteRef.current = note;
            setLastUpdate(Date.now());
          } else if (Date.now() - lastUpdate > 50) {
            setDetectedNote(pendingNoteRef.current);
            setClarity(clarityValue);

            const pitchData = {
              note: note,
              augmentedNote: closest.note,
              pitch: pitch,
              centsOff: centsDifference,
            };
            onPitchDetected(pitchData);
            
            console.log(
`Detected Note: ${pendingNoteRef.current}, Clarity: ${clarityValue.toFixed(2)}
Pitch: ${pitch}
Cents diff: ${centsDifference} (from ${closest.note} aka ${closest.frequency})`);
          }

        } else {
          pendingNoteRef.current = null;
          setDetectedNote(null);
          setClarity(0);
        }
      };


    }).catch(error => {
      console.error('Microphone access denied:', error);
    });

    // Convert pitch (in Hz) to a musical note name
    function pitchToNote(pitch) {
      const noteStrings = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
      const log2 = Math.log2(pitch / 440);
      const noteNum = Math.round(12 * log2) + 69;
      return noteStrings[noteNum % 12];
    }

    // Cleanup on unmount
    return () => {
      audioContext.close();
    };
  }, []);

  if (visible) {
    return (
      <div className='pitchDetector'>
        <h2>Detected Note: {detectedNote}</h2>
        <p>Clarity: {clarity.toFixed(2)}</p>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default PitchDetectorComponent;
